import { immediateToast } from "izitoast-react";

export const errorMessage = (message) => {
  immediateToast("error", {
    message,
    position: "topCenter",
  });
};
